import { DEFAULT_LANGUAGE_ID, isDefaultLanguageId } from "@/utils/languageUtils";



export type FieldTranslationRow = {

  id?: number;

  Id?: number;

  key?: string;

  Key?: string;

  englishText?: string;

  languageId?: number | string;

  translation?: string;

  humanEdited: boolean;

  HumanEdited?: boolean;

};



const TRANSLATION_KEY_PATTERN = /^[a-z][a-z0-9]*(?:\.[a-z][a-z0-9]*)+$/i;



export function isFieldTranslationKey(value: string | null | undefined): boolean {

  const normalized = String(value || "").trim();

  return !!normalized && TRANSLATION_KEY_PATTERN.test(normalized);

}



export function applyTemplate(text: string, templateValues?: Record<string, unknown> | null): string {

  if (!templateValues) return text;

  return Object.entries(templateValues).reduce((next, [key, value]) => {

    return next.replaceAll(`{${key}}`, String(value));

  }, text);

}



function getRowKey(row: FieldTranslationRow | null | undefined): string {

  return String(row?.key || row?.Key || "").trim();

}



export function createFieldTranslator(

  fieldTranslations: FieldTranslationRow[] = [],

  currentLanguageId: number | string = DEFAULT_LANGUAGE_ID

) {

  function resolveByKey(

    key: string,

    fallbackText: string,

    templateValues?: Record<string, unknown> | null

  ): string | null {

    const resolvedFallback = applyTemplate(fallbackText, templateValues || undefined);

    if (isDefaultLanguageId(currentLanguageId)) return resolvedFallback;



    const normalizedKey = key.trim().toLowerCase();

    const match = fieldTranslations.find(

      (item) =>

        getRowKey(item).toLowerCase() === normalizedKey &&

        Number(item?.languageId || 0) === Number(currentLanguageId)

    );



    const translated = String(match?.translation || "").trim();

    return translated ? applyTemplate(translated, templateValues || undefined) : null;

  }



  function t(

    englishTextOrKey: string,

    fallbackText: string = englishTextOrKey,

    templateValues?: Record<string, unknown> | null

  ): string {

    const primary = String(englishTextOrKey || "").trim();

    const resolvedFallback = applyTemplate(fallbackText, templateValues || undefined);



    if (isDefaultLanguageId(currentLanguageId)) return resolvedFallback;

    if (!Array.isArray(fieldTranslations) || fieldTranslations.length === 0) return resolvedFallback;



    if (isFieldTranslationKey(primary)) {

      const byKey = resolveByKey(primary, resolvedFallback, templateValues);

      if (byKey != null) return byKey;

    }



    const candidates = [

      primary,

      String(resolvedFallback || "").trim(),

    ].filter((value, index, arr) => !!value && arr.indexOf(value) === index);



    const normalizedCandidates = new Set(candidates.map((value) => value.toLowerCase()));

    const candidateMatches = fieldTranslations.filter(

      (item) =>

        normalizedCandidates.has(String(item?.englishText || "").trim().toLowerCase()) &&

        Number(item?.languageId || 0) === Number(currentLanguageId)

    );



    const match =

      candidateMatches.find((item) => String(item?.translation || "").trim().length > 0) ||

      candidateMatches[0];



    const translated = String(match?.translation || "").trim();

    return translated ? applyTemplate(translated, templateValues || undefined) : resolvedFallback;

  }



  function tKey(

    key: string,

    fallbackText: string,

    templateValues?: Record<string, unknown> | null

  ): string {

    const resolved = resolveByKey(key, fallbackText, templateValues);

    if (resolved != null) return resolved;

    return applyTemplate(fallbackText, templateValues || undefined);

  }



  return Object.assign(t, { key: tKey });

}


